function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.535 8.098l-8.769 5.914a1 1 0 01-1.559-.83V1.356a1 1 0 011.56-.83l8.768 5.915a1 1 0 010 1.658zM1 .224h.57a1 1 0 011 1v12a1 1 0 01-1 1H1a1 1 0 01-1-1v-12a1 1 0 011-1z",
  fill: "#656D78",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15"
  }, props), _ref);
};

export default SvgComponent;